module.exports = __webpack_public_path__ + "img/link-air-white.8c1a5d0c.svg";